module.exports = __webpack_public_path__ + "static/media/owlsfx.11e53683.wav";